import { MainList } from "@/classes/MainList";
import { agentApi } from "@/getinfo-api";
import agentsList, { AgentListParams } from "@/getinfo-api/agent";
import { getCurrentCompanyId } from "@/plugins/roles";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import { uniqBy } from "lodash";

export class AgentListClass extends MainList {
  params: AgentListParams = {
    conditionsIds: [],
    sort: "updatedAt",
    order: "DESC",
    companyId: getCurrentCompanyId(),
    offset: 0,
    limit: 30
  };

  constructor(params?: AgentListParams, selectedValue?: string | undefined) {
    super();
    this.method = agentsList;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    if (selectedValue) {
      this.singleMethod = () => agentApi.Agent.getAgent(selectedValue);
      this.single();
    }
    this.list();
  }

  async search(value: string) {
    const firstName: AgentListParams = {
      firstName: value,
      offset: 0,
      limit: 30
    };
    const lastName: AgentListParams = {
      lastName: value,
      offset: 0,
      limit: 30
    };
    const middleName: AgentListParams = {
      middleName: value,
      offset: 0,
      limit: 30
    };
    this.isLoading = true;
    this.listItems = [];
    await Promise.allSettled(
      [firstName, lastName, middleName].map(async params => {
        let { data } = await agentsList(params);
        if (data?.items?.length) {
          this.listItems = [...this.listItems, ...data.items];
        }
      })
    );
    this.listItems = uniqBy(this.listItems, "id");
    this.isLoading = false;
  }

  get agents(): IAgent[] {
    return this.listItems;
  }
}
